<template>
  <div class="card-container">
    <div class="card-content">
      <img src="@/assets/images/card/title-bg.svg" class="bg-card">
      <div class="labour-love">
        <img src="@/assets/images/labour-love.svg">
      </div>
      <div class="celebrate">
        <div>Celebrating our Sinai Babies</div>
      </div>
      <div class="card-icons">
        <img :src="require( `@/assets/images/card/svg1.svg` )" class="icon-svg">
        <img :src="require( `@/assets/images/card/svg2.svg` )" class="icon-svg">
        <img :src="require( `@/assets/images/card/svg3.svg` )" class="icon-svg">
        <img :src="require( `@/assets/images/card/svg4.svg` )" class="icon-svg">
      </div>
      <div class="sinaibabies">sinaibabies.ca</div>
      <!-- <img :src="require( `@/assets/images/bears/bear.svg` )" class="bear"> -->
      <bear-card class="bear"></bear-card>
    </div>
  </div>
</template>

<script>
import { TimelineMax, Linear, Power2, Power3, Sine } from 'gsap/TweenMax'
import BearCard from '@/components/TitleSlide/BearCard.vue'

export default {
  name: 'TitleSlide',
  components: { BearCard },
  data () {
    return {
      tl: new TimelineMax(),
      tlWaveLoop: new TimelineMax(),
      tlBlinkLoop: new TimelineMax({ repeat: -1, repeatDelay: 1 }),
      tlHeadLoop: new TimelineMax({ repeat: -1, repeatDelay: 1 })
    }
  },
  mounted () {
    this.$store.commit('BEARS_EXIT', false)

    const arm = this.$el.querySelector('.bear-home .arm')
    const head = this.$el.querySelectorAll('.bear-home .head')
    const ear1 = this.$el.querySelectorAll('.bear-home .ear1')
    const ear2 = this.$el.querySelectorAll('.bear-home .ear2')
    const eyes = this.$el.querySelectorAll('.bear-home .eye')
    const brow1 = this.$el.querySelector('.bear-home .brow1')
    const brow2 = this.$el.querySelector('.bear-home .brow2')
    const mouth = this.$el.querySelector('.bear-home .mouth')
    const mouthProps = {
      scaleX: 1.2,
      transformOrigin: '50% 100%',
      ease: Sine.easeInOut,
      yoyo: true,
      repeat: 1
    }

    this.tlWaveLoop
      .to(arm, 1, {
        xPercent: 7,
        yPercent: -3,
        rotation: -8,
        ease: Linear.easeNone,
        transformOrigin: '85% 90%',
        yoyo: true,
        repeat: -1
      })

    this.tlHeadLoop
      .to(head, 1.5, {
        xPercent: 1,
        yPercent: -5,
        rotation: -8,
        ease: Linear.easeNone,
        transformOrigin: '85% 90%',
        yoyo: true,
        repeat: 1
      }, 0)
      .to(ear1, 1.5, {
        xPercent: -5,
        yPercent: 6,
        rotation: 15,
        ease: Linear.easeNone,
        transformOrigin: '100% 100%',
        yoyo: true,
        repeat: 1
      }, 0)
      .to(ear2, 1.5, { xPercent: -12, yPercent: 8, rotation: -10, ease: Linear.easeNone, yoyo: true, repeat: 1 }, 0)

    this.tlBlinkLoop
      .add('blink1', 1)
      .to(eyes, 0.24, {
        scaleY: 0,
        ease: Linear.easeNone,
        transformOrigin: '50% 90%',
        yoyo: true,
        repeat: 1
      }, 'blink1')
      .to(brow1, 0.24, {
        xPercent: 5,
        yPercent: 10,
        ease: Linear.easeNone,
        rotation: -5,
        transformOrigin: '50% 50%',
        yoyo: true,
        repeat: 1
      }, 'blink1')
      .to(brow2, 0.24, {
        xPercent: -5,
        yPercent: 10,
        ease: Linear.easeNone,
        rotation: 5,
        transformOrigin: '50% 50%',
        yoyo: true,
        repeat: 1
      }, 'blink1')
      .add('blink2', 5)
      .to(eyes, 0.24, {
        scaleY: 0,
        ease: Linear.easeNone,
        transformOrigin: '50% 90%',
        yoyo: true,
        repeat: 3
      }, 'blink2')
      .to(brow1, 0.24, {
        xPercent: 5,
        yPercent: 10,
        ease: Linear.easeNone,
        rotation: -5,
        transformOrigin: '50% 50%',
        yoyo: true,
        repeat: 3
      }, 'blink2')
      .to(brow2, 0.24, {
        xPercent: -5,
        yPercent: 10,
        ease: Linear.easeNone,
        rotation: 5,
        transformOrigin: '50% 50%',
        yoyo: true,
        repeat: 3
      }, 'blink2')
      .to(mouth, 0.85, mouthProps, 'blink1')
      .to(mouth, 0.85, mouthProps, 'blink2')

    this.tl
      .delay(1.5)
      .from('.bg-card', 1.5, { yPercent: -120, ease: Power2.easeInOut })
      .from('.bear', 1.5, { yPercent: 120, ease: Power2.easeInOut }, '-=1.2')
      .from('.celebrate > div', 1.2, { yPercent: 200, ease: Power2.easeOut }, '-=0.9')
      .from('.labour-love', 0.7, {
        scale: 0,
        opacity: 0,
        transformOrigin: 'center center',
        ease: Power3.easeOut
      }, '-=0.7')
      .staggerFrom('.icon-svg', 0.7, {
        scale: 0,
        opacity: 0,
        transformOrigin: 'center center',
        ease: Power3.easeOut
      }, 0.15, '-=0.5')
      .from('.sinaibabies', 0.5, { opacity: 0 }, '-=0.6')
  },
  beforeDestroy () {
    this.tl.kill()
    this.tlWaveLoop.kill()
    this.tlBlinkLoop.kill()
    this.tlHeadLoop.kill()
  }
}
</script>

<style scoped>
  .card-container {
    position: relative;
    text-align: center;
    display: flex;
    height: 100vh;
    align-items: center;
    justify-content: center;
    z-index: 3;
    overflow: hidden;
  }

  .card-content {
    position: relative;
    height: auto;
    width: auto;
    /* max-width: 900px;
    margin-top: 50px; */
    z-index: 3;
    top: 3vh;
  }

  .card-content img {
    max-width: 100%;
    max-height: 100%;
  }

  .bg-card {
    width: auto;
    height: 82vh;
  }

  .labour-love {
    top: -3%;
    position: absolute;
    width: 100%;
    height: 29vh;
    text-align: center;
  }

  .labour-love img {
    height: 100%;
    width: auto;
  }

  .card-icons {
    position: absolute;
    width: 100%;
    top: 47.2vh;
  }

  .icon-svg {
    width: auto;
    height: 16vh;
    display: inline-block;
    padding: 0px 1.7vh;
  }

  .celebrate {
    color: #56BFCA;
    font-weight: 500;
    font-size: 8.4vh;
    line-height: 1;
    padding: 30px 0px;
    overflow: hidden;
    position: absolute;
    width: 100%;
    top: 28vh;
  }

  .sinaibabies {
    color: #56BFCA;
    font-size: 4.5vh;
    line-height: 1;
    z-index: 3;
    position: absolute;
    width: 100%;
    bottom: 10.3vh;
    letter-spacing: 0.05em;
  }

  .bear {
    position: absolute;
    height: 65vh;
    bottom: -32vh;
    right: -14vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/TitleSlide.vue